import React from 'react';
import { Card, Stack, Box, Typography } from '@mui/material';

interface QuizStatsProps {
  setName: string;
  mastered: number;
  remaining: number;
}

export const QuizStats: React.FC<QuizStatsProps> = ({ setName, mastered, remaining }) => {
  return (
    <Card sx={{ p: 3, mb: 3, borderRadius: 3, boxShadow: 2, backgroundColor: 'background.paper' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            Current Set
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {setName}
          </Typography>
        </Box>
        <Stack direction="row" spacing={3}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="subtitle2" color="success.main" align="center" sx={{ fontWeight: 'bold' }}>
              {mastered}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Mastered
            </Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="subtitle2" color="text.secondary" align="center" sx={{ fontWeight: 'bold' }}>
              {remaining}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Remaining
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Card>
  );
};
